
export const get6ESdata = { 
    query: `query get6ESdata($farmId: Int) {
        get6ESdata(farmId: $farmId)
    }`
};
